var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.count > 0,
          expression: "count > 0",
        },
      ],
      staticClass: "sm-tab",
    },
    [
      _vm._l(_vm.showNavList, function (value, key, index) {
        return [
          value.show
            ? _c(
                "a",
                {
                  key: index,
                  class: [
                    _vm.type === key && _vm.count > 1 ? "cur" : "",
                    "tab",
                  ],
                  attrs: { id: key },
                  on: { click: _vm.navClick },
                },
                [_vm._v("\n      " + _vm._s(value.content) + "\n    ")]
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }